import React, { useCallback, useEffect, useState } from "react"
import { Paper, TableCell, TableRow } from "@material-ui/core"
import {
  DatatablesFooterServerSide,
  Title,
  TableCellDefault,
  Loading,
  ModalDeleteConfirm,
  TableAction,
} from "App/Component/ui"

import {
  FormKunjunganIgd,
  headCells,
  STYLE_MASTER_GUDANG_UTAMA,
  RESET_STATE_KUNJUNGAN_IGD,
  FormFilterKunjunganIgd,
  RESET_STATE_FORM_FILTER,
  getByFilterKunjunganIgd,
  deleteKunjunganIgdById,
} from "./ui"

import { useDatatables, useDatatablesServerSide } from "App/hooks"
import {
  convertDateToValidInput,
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  getAge,
  scrollToTop,
  today,
} from "App/utils/helpers"
import { ModalKunjunganBaru } from "../KunjunganRawatJalan/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import {
  CountHarian,
  getCaraMasuk,
  prefixNoRM,
  StatusKunjungan,
} from "../utils"
import { FreezeTable } from "components/organism"
import { dateFormat } from "utils/dates"

export default function KunjunganIgd() {
  const classes = STYLE_MASTER_GUDANG_UTAMA()
  const [showModalKunjunganBaru, setShowModalKunjunganBaru] = useState(false)

  const [rows, setRows] = useState([])
  const [formData, setFormData] = useState(RESET_STATE_KUNJUNGAN_IGD)
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER)
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(false)
  const [registrationId, setRegistrationId] = useState("")
  useEffect(() => {
    ;(async () => {
      await setNewData()
    })()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const countHarian = CountHarian(
    "/registration/registration/countregistration_onsiteigd",
  )

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
  ) => {
    setLoading(true)
    const res = await getByFilterKunjunganIgd(formFilter, pages, limit)
    if (res.state) {
      setRows(res.data)
      setTotalData(res.meta.count)
      setLoading(false)
    } else {
      setRows([])
      setLoading(false)
      defaultToastError(res.message)
    }
  }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({ setNewData: setNewData })

  const handleClickButtonKunjunganBaru = () => {
    setShowModalKunjunganBaru(!showModalKunjunganBaru)
  }

  const handleClickSelect = (row) => {
    setFormData({
      ...RESET_STATE_KUNJUNGAN_IGD,
      date: today(true),
      patients_id: row?.id,
      nama_rm: row?.fullname,
      norm: row.norm,
      gender: row?.gender === 1 ? "Laki-laki" : "Perempuan",
      gender_print: row.gender,
      umur: getAge(
        dateFormat({ date: row?.date_ob, formatDate: "YYYY-MM-DD" }),
      ),
      date_ob: row.date_ob,
      nohp: row?.mobile_phone_number,
      phone_number: row?.phone_number,
      address_now: row?.address_now,
      penanggung: row?.guarantor_name,
      pekerjaan: row?.pekerjaan_name,
      nik: row?.nik,

      company_id: row?.company_id,
      company_name: row?.company_name,
      insurance_no: row?.insurance_number,
      insurance_id: row?.insurance_id,
      insurance_name: row?.insurance_name,
    })
    setShowModalKunjunganBaru(false)
  }

  const handleClickUpdate = (row) => {
    setRegistrationId(row?.id)
    setFormData({
      ...formData,
      date: defaultDateInputDisplay(row?.date, true),
      nama_rm: row?.rm_name,
      umur: row?.umur,
      nik: row?.nik,
      typeofcare_code: row?.typeofcare_code,

      jenis_layanan_id: row?.jenis_layanan_id,
      kelaskunjungan_id: row?.kelaskunjungan_id,

      patients_id: row?.patients_id,
      norm: prefixNoRM(row.patients_id),

      id_triage: row?.id_triage,
      label_triage: row?.id_triage,

      company_id: row?.company_id,
      company_name: row?.company_name,

      insurance_id: row?.insurance_id,
      insurance_name: row?.insurance_name,

      insurance_no: row?.insurance_no,
      nohp: row?.nohp,
      norujukan: row?.norujukan,

      nokontrol: row?.nokontrol,

      penanggung: row?.rm_guarantor_name,
      pekerjaan: row?.rm_occupation_name,
      phone_number: row?.rm_phone_number,
      address_now: row?.rm_address_now,

      gender: row?.rm_gender === 1 ? "Laki-Laki" : "Perempuan",
      gender_print: row?.rm_gender,

      sebab_sakit: row?.sebab_sakit,

      isexternalrm: false,
      date_ob: row?.rm_date_ob,

      insurance_type_name: row?.insurance_type_name,
      doctor_id: row?.doctor_id,
      doctor_name: row?.doctor_fullname,
      no_sep: row.no_sep,
      status: row?.status,
      remark: row?.remark,
      cara_masuk: row?.cara_masuk,
      cara_masuk_name: getCaraMasuk(row.cara_masuk)?.cara_masuk_name,
    })
    scrollToTop()
  }

  const handleKeyPress = useCallback((event) => {
    if (event.key === "F4") {
      setShowModalKunjunganBaru(true)
    }

    if (event.key === "F6") {
      setRegistrationId(null)
      setFormData(RESET_STATE_KUNJUNGAN_IGD)
    }
  }, [])

  React.useEffect(() => {
    document.addEventListener("keydown", handleKeyPress)
    return () => {
      document.removeEventListener("keydown", handleKeyPress)
    }
  }, [handleKeyPress])

  return (
    <div className={classes.root}>
      {showModalKunjunganBaru && (
        <ModalKunjunganBaru
          formData={formData}
          setFormData={setFormData}
          onlyInternal={true}
          handleClickSelect={handleClickSelect}
          setShowModal={() => setShowModalKunjunganBaru(false)}
        />
      )}

      <Title title="Kunjungan IGD" />

      <FormKunjunganIgd
        formData={formData}
        setFormData={setFormData}
        setRows={setRows}
        setNewData={setNewData}
        handleClickButtonKunjunganBaru={handleClickButtonKunjunganBaru}
        registrationId={registrationId}
        setRegistrationId={setRegistrationId}
      />

      <div className="mt-2">
        <Paper className={classes.paper}>
          <FormFilterKunjunganIgd
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
            countHarian={countHarian}
            withExportButton={true}
            resetPagination={resetPagination}
          />

          <Loading show={loading} />
          <TableIgd
            classes={classes}
            rows={rows}
            setNewData={setNewData}
            handleClickUpdate={handleClickUpdate}
          />

          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>

      <ul
        style={{
          fontSize: "11px",
          marginTop: "2rem",
          padding: "1rem",
        }}
      >
        <li>Gunakan F4 untuk memunculkan modal kunjungan baru </li>
        <li>Gunakan F6 untuk untuk reset form</li>
      </ul>
    </div>
  )
}

const TableIgd = ({ rows, handleClickUpdate, setNewData }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "date",
    orderByRow: ["id", "date"],
  })
  const [registrationId, setRegistrationId] = useState("")

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)

  async function deleteList() {
    const res = await deleteKunjunganIgdById(registrationId)

    if (res.state) {
      defaultToastSuccess(res.message)
      await setNewData(1, 10)
    } else {
      defaultToastError(res.message)
    }

    setShowModalDeleteConfirm(false)
  }

  function handleClickDelete(row) {
    setRegistrationId(row.id)
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <FreezeTable
        headCells={headCells}
        handleRequestSort={handleRequestSort}
        order={order}
        length={length}
        orderBy={orderBy}
      >
        {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
          return (
            <TableRow hover key={index}>
              <TableCell align="center">{index + 1}</TableCell>

              <TableCell align="center">
                <TableAction
                  clickDelete={() => handleClickDelete(row)}
                  clickUpdate={() => handleClickUpdate(row)}
                />
              </TableCell>
              <TableCell align="left">{row?.id}</TableCell>
              <TableCell align="left">{row?.patients_id}</TableCell>
              <TableCell align="left">
                {row?.isexternalrm ? row?.rm_name_external : row?.rm_name}
              </TableCell>

              <TableCell align="left">{row?.tagihan_id}</TableCell>
              <TableCell align="left">
                {defaultDateDisplay(row?.date, true)}
              </TableCell>
              <TableCell align="left">
                <StatusKunjungan status={row.status} iscancel={row.iscancel} />
              </TableCell>
              <TableCell align="left">{row?.nohp}</TableCell>
              <TableCell align="left">{row?.rm_phone_number}</TableCell>
              <TableCell align="left">{row?.doctor_fullname}</TableCell>
              <TableCell align="left">{row?.company_name}</TableCell>
              <TableCell align="left">{row?.insurance_name}</TableCell>
              <TableCell align="left">{row?.insurance_no}</TableCell>
              <TableCell align="left">{row?.no_sep}</TableCell>

              <TableCell align="center">
                {row?.isexternalrm
                  ? defaultDateDisplay(row?.date_ob_external, false)
                  : defaultDateDisplay(row?.rm_date_ob, false)}
              </TableCell>
              <TableCell align="center">{row?.umur}</TableCell>

              <TableCell align="left">{row.nama_ppk_perujuk}</TableCell>
              <TableCell align="left">{row?.nama_hak_kelas}</TableCell>
              <TableCell align="left">{row?.remark}</TableCell>
              <TableCell align="left">{row?.whycancel}</TableCell>

              <TableCellDefault row={row} />
            </TableRow>
          )
        })}
        {rows.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={headCells.length}>
              Tidak ada data
            </TableCell>
          </TableRow>
        )}
      </FreezeTable>
    </>
  )
}
